"use client";

import { useState } from "react";
import { createPortal } from "react-dom";
import "./Itinerario.css";

export default function Itinerario() {
  const [mostrarMapa, setMostrarMapa] = useState(false);

  const abrirMapa = () => setMostrarMapa(true);
  const cerrarMapa = () => setMostrarMapa(false);

  const ModalMapa = () =>
    createPortal(
      <div className="modal-mapa">
        <div className="modal-contenido">
          <button className="btn-cerrar" onClick={cerrarMapa}>
            &times;
          </button>
          <h3>Dirección</h3>
          <p>Miguel de Unamuno 5567, Del Viso, Buenos Aires</p>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3289.2939764819794!2d-58.79143459999999!3d-34.4700659!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bc99238528e36b%3A0xce6196a482c7a775!2sMiguel%20de%20Unamuno%205567%2C%20B1669HCA%20Del%20Viso%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses-419!2sar!4v1758647394793!5m2!1ses-419!2sar"
            width="100%"
            height="400"
            style={{ border: 0, borderRadius: "12px", marginTop: "1rem" }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Mapa"
          ></iframe>
        </div>
      </div>,
      document.body
    );

  return (
    <section className="seccion itinerario">
      <div className="evento-bloque">

        <img src="/calen.gif" alt="Calendario" className="icono-anillos" />

        <h2 className="titulo-general">Agenda la fecha</h2>

        <p className="fecha-evento">Sábado 22 de Nov de 2025</p>

        <hr className="linea-separadora" />

        <img src="/cheers.gif" alt="Brindis" className="icono-brindis" />


        <h3 className="subtitulo-evento celebracion">Celebración</h3>
        <p>18:00 hs.</p>

        <button className="btn-mapa" onClick={abrirMapa}>
          Cómo llegar
        </button>

      </div>

      {mostrarMapa && <ModalMapa />}
    </section>
  );
}
